import React, { Component } from 'react';
import { connect } from 'react-redux';
import AppLayout from '../AppLayout';
import { withRouter } from 'react-router-dom';
import { listReward, listMarketplace, deleteReward, listUsersByMarketplace } from '../../Api';
import { format } from '../../share/date'
import InputSelect from '../InputSelect';
class RewardIndex extends Component {
  state = {
    name: "",
    marketplace: {},
    marketplaces: [],
    lottery: {},
    lotteries: [],
    users: [],
    user: {},
    qr: ''
  };

  setLottery(marketplace) {
    const lotteries = marketplace.lotteryList || [];
    const lottery = lotteries && lotteries.length > 0 ? lotteries[0] : {};
    this.setState({ marketplace, lotteries, lottery });
    this.setUser(marketplace)
    this.setTicket({ lottery, user: '' })
  }

  setTicket({ lottery, user, qr }) {
    this.props.dispatch({
      type: 'setReward',
      payload: []
    })
    if (lottery && lottery._id) {
      listReward({
        token: this.props.usuario.token,
        params: {
          lottery: lottery && lottery._id ? lottery._id : '',
          user: user && user._id ? user._id : '',
          qr
        }
      }).then(list => {
        this.props.dispatch({
          type: 'setReward',
          payload: list
        })
      })
    }
  }

  setUser(marketplace) {
    listUsersByMarketplace(
      marketplace._id,
      this.props.usuario.token
    ).then(list => {
      const users = list || []
      users.unshift({})
      this.setState({ users })
    })
  }

  componentDidMount() {
    this.loadData();
  }

  handleSubmit = async event => {
    event.preventDefault();
  };

  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
    document.getElementById(event.target.id).classList.remove("is-danger");
  };

  loadData() {
    listMarketplace(this.props.usuario.token).then(marketplaces => {
      if (marketplaces && marketplaces.length > 0) {
        const marketplace = marketplaces[0];
        this.setLottery(marketplace);
      }
    });
  }

  render() {
    const { rewards } = this.props
    return (
      <AppLayout>
        <div className="content">
          <div className='form-horizontal'>
            <h2>Premios</h2>
            <button className='btn btn-primary' onClick={(event) => {
              event.preventDefault();
              this.props.history.push('/rewards/new')
            }}>Nuevo</button>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className='form-group'>
                <InputSelect
                  keyField="_id"
                  label="Plazas"
                  readOnly={this.props.readOnly}
                  row={this.state.marketplace}
                  rows={this.props.marketplaces}
                  format={(data) => { return data.name }}
                  onChange={(data) => { this.setLottery(data) }}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className='form-group'>
                <InputSelect
                  keyField="_id"
                  label="Sorteos"
                  readOnly={this.props.readOnly}
                  row={this.state.lottery}
                  rows={this.state.lotteries}
                  format={(data) => {
                    const date = data.created_at ? format({ date: data.created_at }) : ''
                    const actived = data.active ? 'SI' : 'NO'
                    return `${date} - ${actived}`
                  }}
                  onChange={(lottery) => {
                    this.setState({ lottery })
                    this.setTicket({
                      lottery,
                      user: this.state.user,
                      qr: this.state.qr
                    })
                  }}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className='form-group'>
                <InputSelect
                  keyField="_id"
                  label="Vendedor"
                  readOnly={this.props.readOnly}
                  row={this.state.user}
                  rows={this.state.users}
                  format={(data) => {
                    return data.name
                  }}
                  onChange={(user) => {
                    this.setState({ user })
                    this.setTicket({
                      user,
                      lottery: this.state.lottery,
                      qr: this.state.qr
                    })
                  }}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className='form-group'>
                <label htmlFor="created_at">Número</label>
                <input
                  className="form-control"
                  type="qr"
                  id='qr'
                  value={this.state.qr}
                  onChange={e => {
                    this.onInputChange(e)
                    this.setTicket({
                      user: this.state.user,
                      lottery: this.state.lottery,
                      qr: e.target.value
                    })
                  }}

                />
              </div>
            </div>
          </div>
          {rewards && rewards.length > 0 ? (
            <table className="table table-responsive">
              <thead>
                <tr>
                  <th colSpan={6}>Total: {rewards.length}</th>
                </tr>
                <tr>
                  <td>#</td>
                  <td>Acciones</td>
                  <td>Fecha</td>
                  <td>Activo</td>
                  <td>QR</td>
                  <td>Valor</td>
                </tr>
              </thead>
              <tbody>
                {rewards.map((item, index) => {
                  return (<tr key={`${item._id}`}>
                    <td>{index + 1}</td>
                    <td>
                      <button className='btn btn-sm btn-default' onClick={() => {
                        const ok = window.confirm('¿Seguro que quieres borrar el premio?')
                        if (ok) {
                          deleteReward(item.reward._id, this.props.usuario.token)
                            .then(ok => {
                              this.loadData();
                            })
                            .catch(err => {
                              console.log(err)
                            })
                        }
                      }}>Borrar</button>
                    </td>
                    <td>{format({ date: new Date(item.created_at) })}</td>
                    <td>{item.active ? 'SI' : 'NO'}</td>
                    <td>{item.qr}</td>
                    <td>{item.reward && item.reward.value}</td>
                  </tr>)
                })}
              </tbody>
            </table>
          ) : (
            <div className="alert alert-info">
              <span>Sin datos</span>
            </div>
          )}
        </div>
      </AppLayout>
    );
  }
}

const mapStoreToProps = (state, props) => {
  return {
    ...props,
    usuario: state.usuario,
    rewards: state.rewards,
    marketplaces: state.marketplaces
  }
}
export default withRouter(connect(mapStoreToProps)(RewardIndex));